import './innovative/style';
import FormStructure from './innovative/form_structure';

export default FormStructure;